import React from 'react';
import S from './Main.template.style';
import type { IUTMainTemplate } from './types/Main.template.types';
import { SidebarNav } from '@/Shared/components/SidebarNav/SidebarNav';

export const MainTemplate: React.FC<IUTMainTemplate> = ({
  id,
  children,
  sidebarOptions,
}: IUTMainTemplate) => {
  return (
    <S.MainContainer id={id}>
      <SidebarNav {...sidebarOptions} />
      {children}
    </S.MainContainer>
  );
};
